import { render, staticRenderFns } from "./WorkContainer.vue?vue&type=template&id=21b8f91a"
import script from "./WorkContainer.vue?vue&type=script&lang=js"
export * from "./WorkContainer.vue?vue&type=script&lang=js"
import style0 from "./WorkContainer.vue?vue&type=style&index=0&id=21b8f91a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports